
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { GenerarReportesFuncionariosComponent } from './generar-reportes-funcionarios.component';
import { GenerarReportesFuncionariosRouting } from './generar-reportes-funcionarios.routing.module';
import { GenerarReporteUsoBicicletaComponent } from './reporte-uso-bicicleta/generar-reporte-uso-bicicleta.component';
import { ReporteCompensacionBicicletaComponent } from './reporte-compensacion-bicicleta/reporte-compensacion-bicicleta.component';
import { ReporteDetalleFuncionarioComponent } from './reporte-detalle-funcionario/reporte-detalle-funcionario.component';
import { ReporteAuditoriaFuncionarioComponent } from './reporte-auditoria-funcionario/reporte-auditoria-funcionario.component';



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}


@NgModule({
  declarations: [GenerarReportesFuncionariosComponent,
    GenerarReporteUsoBicicletaComponent,
    ReporteCompensacionBicicletaComponent,
    ReporteDetalleFuncionarioComponent,
    ReporteAuditoriaFuncionarioComponent],
  imports: [
    GenerarReportesFuncionariosRouting,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  entryComponents: []
})

export class GenerarReportesFuncionariosModule { }
